import equal from 'fast-deep-equal/es6/react';
import * as R from 'remeda';
import { createSelectorCreator, defaultMemoize } from 'reselect';

const createDeepEqualSelector = createSelectorCreator(defaultMemoize, (a, b) =>
  a || b === null ? R.isDeepEqual(a, b) : equal(a, b)
);

export default createDeepEqualSelector;
